import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../shared/services/interfaces/generic-http-response.interface';
import {
  PropuestaComercial,
  PropuestaComercialFiltros,
  PropuestaComercialPaginatedResponse,
  PropuestaComercialPayload
} from './propuestas-comerciales.interface';

@Injectable({
  providedIn: 'root'
})
export class PropuestasComercialesService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(
    page: number = 1,
    perPage: number = 15,
    filtros: Partial<PropuestaComercialFiltros> = {}
  ): Observable<GenericHttpResponse<PropuestaComercialPaginatedResponse>> {
    const params: any = {
      page,
      per_page: perPage,
      ...filtros
    };
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });
    const url = this.httpCommonService.makeUrl('/crms/propuestasComerciales', params);
    return this.http.get<GenericHttpResponse<PropuestaComercialPaginatedResponse>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<PropuestaComercial>> {
    const url = this.httpCommonService.makeUrl(`/crms/propuestasComerciales/${id}`);
    return this.http.get<GenericHttpResponse<PropuestaComercial>>(url);
  }

  store(body: FormData): Observable<GenericHttpResponse<PropuestaComercial>> {
    const url = this.httpCommonService.makeUrl('/crms/propuestasComerciales');
    return this.http.post<GenericHttpResponse<PropuestaComercial>>(url, body);
  }

  update(id: number, body: PropuestaComercialPayload): Observable<GenericHttpResponse<PropuestaComercial>> {
    const url = this.httpCommonService.makeUrl(`/crms/propuestasComerciales/${id}`);
    return this.http.put<GenericHttpResponse<PropuestaComercial>>(url, body);
  }

  updateArchivo(id: number, body: FormData): Observable<GenericHttpResponse<PropuestaComercial>> {
    const url = this.httpCommonService.makeUrl(`/crms/propuestasComerciales/${id}/archivo`);
    return this.http.post<GenericHttpResponse<PropuestaComercial>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<PropuestaComercial>> {
    const url = this.httpCommonService.makeUrl(`/crms/propuestasComerciales/${id}`);
    return this.http.delete<GenericHttpResponse<PropuestaComercial>>(url);
  }

  download(id: number): Observable<Blob> {
    const url = this.httpCommonService.makeUrl(`/crms/propuestasComerciales/${id}/descargar`);
    return this.http.get(url, { responseType: 'blob' });
  }
}
